<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2025-02-26 16:54:50
 * @LastEditors: xiawenlong
 * @LastEditTime: 2025-12-26 11:48:04
-->
<template>
  <el-dialog
    width="800px"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    append-to-body
    top="5vh"
  >
    <div class="cropper-wrapper">
      <vue-cropper
        ref="cropper"
        :img="imageUrl"
        :info="true"
        :center-box="true"
        :original="false"
        :auto-crop="options.autoCrop"
        :auto-crop-width="options.autoCropWidth"
        :auto-crop-height="options.autoCropHeight"
        :fixed-box="options.fixedBox"
        :fixed="options.fixed"
        :fixed-number="[2, 2.8]"
      ></vue-cropper>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="crop">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { VueCropper } from 'vue-cropper'
export default {
  components: { VueCropper },
  data() {
    return {
      visible: false,
      imageUrl: '',
      options: {
        autoCrop: true, //是否默认生成截图框
        autoCropWidth: 564, //默认生成截图框宽度
        autoCropHeight: 290, //默认生成截图框高度
        fixedBox: false, //固定截图框大小 不允许改变
        fixed: false, //是否固定截图框宽高比例
      },
    }
  },
  methods: {
    open(url) {
      this.imageUrl = url
      this.visible = true
    },
    translateBase64ImgToFile(base64, filename, contentType) {
      var arr = base64.split(',') //去掉base64格式图片的头部
      var bstr = atob(arr[1]) //atob()方法将数据解码
      var leng = bstr.length
      var u8arr = new Uint8Array(leng)
      while (leng--) {
        u8arr[leng] = bstr.charCodeAt(leng) //返回指定位置的字符的 Unicode 编码
      }
      return new File([u8arr], filename, { type: contentType })
    },
    crop() {
      this.$refs.cropper.getCropData(data => {
        let result = this.translateBase64ImgToFile(data, 'testImg.png', 'image/png')
        // 手动上传文件
        this.$emit('cropped', result)
        this.close()
      })
    },
    close() {
      this.visible = false
    },
    handleClose(done) {
      done()
    },
  },
}
</script>

<style scoped>
.cropper-wrapper {
  width: 100%;
  height: 700px;
}
</style>
